import React from 'react';
import { Paper, makeStyles } from '@material-ui/core';

export default function OrderHistoryPage() {
    const classes = useStyles();
    return <div className="background">
                <div className={classes.spacer80}></div>
                <Paper className={classes.paper}>
                    Add history content here
                </Paper>
            </div>
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px'
    },
    paper: {
        padding: '50px',
        margin: "50px",
        height: '70%'
    }
});